import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  forwardRef,
  ViewChild,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { DatePipe } from "@angular/common";

@Component({
  selector: "app-eis-datepicker",
  templateUrl: "./eis-datepicker.component.html",
  styleUrls: ["./eis-datepicker.component.css"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EisDatepickerComponent),
      multi: true,
    },
  ],
})
export class EisDatepickerComponent implements ControlValueAccessor, OnInit {
  @Input() id;
  @Input() name;
  @Input() width = 120;
  @Input() ariaLabel;
  @Input() ariaRequired = false;
  @Input() ariaLabelledBy = "";
  @Input() disabled = false;
  @Output() dateChangeEvent = new EventEmitter();
  @Output() enterKeyEvent = new EventEmitter();
  @Input() enableEnterKeyEvent = false;
  @Input() dateEventFormatMmDdYyyy = "";
  @ViewChild("eisDatepicker") eisDatepicker;
  onChange: any = () => {};
  onTouched: any = () => {};
  curDateValue;
  customId = String(Math.random() * (13904.4953 - 1039.39402) + 4.9);

  constructor(private datePipe: DatePipe) {}

  ngOnInit() {}

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  onDateSelect(event) {
    // console.log('onDateSelect() ' + event.target.valueAsDate);
    // console.log('onDateSelect() ' + event.target.value);
    if (event.target.value !== undefined && event.target.value !== null) {
      // this.curDateValue = this.datePipe.transform(event.target.value, 'yyyy-MM-dd');
      if (event.target.value.length > 10) {
        this.curDateValue = event.target.value.substring(
          event.target.value.length - 10
        );
      } else {
        this.curDateValue = event.target.value;
      }
    } else {
      this.curDateValue = null;
    }
    this.onChange(this.curDateValue);
    this.onTouched();
    if (this.dateEventFormatMmDdYyyy === "") {
      this.dateChangeEvent.emit(this.curDateValue);
    } else {
      const dt = this.datePipe.transform(this.curDateValue, "MM/dd/yyyy");
      this.dateChangeEvent.emit(dt);
    }
  }

  getFormattedDate() {
    if (this.curDateValue !== undefined && this.curDateValue !== null) {
      return this.datePipe.transform(this.curDateValue, "MM/dd/yyyy");
    }
    return "";
  }

  get value() {
    if (this.curDateValue !== undefined && this.curDateValue !== null) {
      return this.datePipe.transform(this.curDateValue, "MM/dd/yyyy");
    }
    return "";
  }

  set value(val) {
    if (val !== undefined && val !== null) {
      //      console.log('date val ' + val);
      //      console.log('transform val ' + this.datePipe.transform(val, 'yyyy-MM-dd'));
      this.curDateValue = this.datePipe.transform(val, "yyyy-MM-dd");
    } else {
      this.curDateValue = null;
    }
    this.onChange(this.curDateValue);
    this.onTouched();
    if (this.dateEventFormatMmDdYyyy === "") {
      this.dateChangeEvent.emit(this.curDateValue);
    } else {
      const dt = this.datePipe.transform(this.curDateValue, "MM/dd/yyyy");
      this.dateChangeEvent.emit(dt);
    }
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  writeValue(value) {
    if (value) {
      this.value = value;
    } else {
      this.value = null;
    }
  }

  getSelectedDateValue(): string {
    if (this.curDateValue !== undefined && this.curDateValue !== null) {
      return this.datePipe.transform(this.curDateValue, "MM/dd/yyyy");
    }
    return "";
  }

  setDate(event) {
    if (event.which == 187) {
      // =
      let date = new Date();
      this.curDateValue = date.toISOString().split("T")[0];
    }
    if (
      this.eisDatepicker.nativeElement.value !== "" &&
      (event.which == 107 ||
        event.which == 109 ||
        event.key === "-" ||
        event.key === "+")
    ) {
      let newDate = new Date(this.eisDatepicker.nativeElement.value);
      if (event.which == 107 || event.key === "+") {
        // +
        newDate.setUTCDate(newDate.getUTCDate() + 1);
      }
      if (event.which == 109 || event.key === "-") {
        // -
        newDate.setUTCDate(newDate.getUTCDate() - 1);
      }
      // newDate.setUTCDate(newDate.getUTCDate() - (event.which - 108)); // This works too
      this.curDateValue = newDate.toISOString().split("T")[0];
    }
    if (event.which === 13 && this.enableEnterKeyEvent === true) {
      this.enterKeyEvent.emit();
    }
  }

  setFocus() {
    console.log('eis-datepicker.setFocus() id = ' + this.customId);
    document.getElementById(this.customId).focus();
  }
}
